import React from "react";
import "./Courses.scss";
import { Helmet } from "react-helmet";
import { Loader } from "rsuite";
import { CourseCard } from "../../entities/Course/components/CourseCard/CourseCard";
import { useGetCoursesQuery } from "../../entities/Course/courseApi";
import { formClass } from "../../shared/helpers";

export const Courses = () => {
	const { data = [], isFetching } = useGetCoursesQuery();

	if (isFetching || !data) {
		return <Loader center content="loading" vertical />;
	}

	const prefixClass = "courses-page";

	// Dynamic page title and description
	const courseTitles = data
		?.filter((course) => course.public)
		.map((course) => course.name)
		.join(", ");

	const pageTitle = "Available Courses - SkillerDome";
	const pageDescription = `Explore our wide range of courses: ${courseTitles}. Start learning today with courses in business, personal growth, and more.`;

	// Generate structured data (JSON-LD) for all available courses
	const courseSchema = {
		"@context": "https://schema.org",
		"@type": "ItemList",
		itemListElement: data
			.filter((course) => course.public)
			.map((course, index) => ({
				"@type": "ListItem",
				position: index + 1,
				item: {
					"@type": "Course",
					name: course.name,
					description: course.description,
					image: course.image,
					provider: {
						"@type": "Organization",
						name: "SkillerDome",
						url: "https://skillerdome.com",
					},
					offers: {
						"@type": "Offer",
						url: `https://skillerdome.com/courses/${course._id}`,
						price: "0", // Indicate the course is free
						priceCurrency: "USD",
						availability: "https://schema.org/InStock",
					},
					hasCourseInstance: {
						"@type": "CourseInstance",
						courseMode: course.category || "General",
						availabilityStarts: "2024-01-01T00:00:00Z",
						location: {
							"@type": "Place",
							name: "SkillerDome Headquarters",
							address: {
								"@type": "PostalAddress",
								streetAddress: "123 Learning Ave",
								addressLocality: "Education City",
								postalCode: "12345",
								addressCountry: "US",
							},
						},
					},
				},
			})),
	};

	return (
		<div className={formClass(prefixClass)}>
			<Helmet>
				<title>{pageTitle}</title>
				<meta name="description" content={pageDescription} />
				<meta
					name="keywords"
					content="courses, online learning, language school, education, skillerDome"
				/>
				<meta name="robots" content="index, follow" />

				{/* JSON-LD structured data */}
				<script type="application/ld+json">
					{JSON.stringify(courseSchema)}
				</script>
			</Helmet>

			<div className={formClass(prefixClass, "container")}>
				{data
					.filter((course) => course.public)
					.map((course) => (
						<CourseCard key={course._id} course={course} />
					))}
			</div>
		</div>
	);
};
